import { render, staticRenderFns } from "./OrderAward.vue?vue&type=template&id=57746f34&scoped=true&"
import script from "./OrderAward.vue?vue&type=script&lang=js&"
export * from "./OrderAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57746f34",
  null
  
)

export default component.exports